import {NgModule} from '@angular/core';
import {CommonModule, DecimalPipe} from '@angular/common';
import {LocalizedDecimalPipe} from './localized-decimal.pipe';


@NgModule({
  declarations: [
    LocalizedDecimalPipe
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    LocalizedDecimalPipe
  ],
  providers: [
      DecimalPipe,
      LocalizedDecimalPipe
  ]
})
export class LocalizedDecimalModule { }
